const translations = {
  'filters.levels': 'Levels',
  'filters.selectLevel': 'Selection of {{level}}',
  'filters.destination': 'Destination',
  'filters.selectDestinations': 'Destination selection',
  'filters.selectPlaces': 'Place selection'
}

export default translations
